import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../api/axios";

const AdminAuthContext = createContext();
const ADMIN_SESSION_KEY = "admin_session";

const readCachedAdmin = () => {
  try {
    return JSON.parse(localStorage.getItem(ADMIN_SESSION_KEY) || "null");
  } catch {
    localStorage.removeItem(ADMIN_SESSION_KEY);
    return null;
  }
};

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdminState] = useState(() => readCachedAdmin());
  const [loading, setLoading] = useState(true);

  const setAdmin = useCallback((nextAdmin) => {
    setAdminState(nextAdmin);
    if (nextAdmin) {
      localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(nextAdmin));
    } else {
      localStorage.removeItem(ADMIN_SESSION_KEY);
    }
  }, []);

  const fetchAdmin = useCallback(async () => {
    try {
      const res = await api.get("/api/auth/me");
      setAdmin(res.data.user);
      return res.data;
    } catch (error) {
      setAdmin(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [setAdmin]);

  useEffect(() => {
    fetchAdmin();
  }, [fetchAdmin]);

  return (
    <AdminAuthContext.Provider value={{ admin, setAdmin, loading, fetchAdmin }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
